<!--@format-->
<template>
    <div class="storefront-data-permission-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Data Permission</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <p class="description">What kind of access would you like to grant your partner?</p>
                <div class="access-container">
                    <div class="choice-container">
                        <div class="container">
                            <app-input-radio v-model="selected" :options="Collaboration" left />
                        </div>
                    </div>
                </div>
                <div class="access-container">
                    <div class="choice-container">
                        <div class="container">
                            <app-input-radio v-model="selected" :options="Analytics" left />
                        </div>
                    </div>
                </div>
                <div class="disclaimer">
                    <label class="header"> Disclaimer </label>
                    <p class="description">
                        By joining this membership you give Connectwise access to view your instance
                        of GlassHive. All data viewed is strictly used to improve our partners'
                        success and provide us with information on how to improve content and
                        process around marketing and sales.
                    </p>
                    <p class="description">
                        As a Preferred partner you must begin the Partner program campaign and
                        within 60 days of partnership approval. You must complete the marketing plan
                        as created or partnership can be canceled by Sponsor.
                    </p>
                    <p class="description">
                        Partnership includes 12 month license,once term is complete or sponsor
                        cancels membership the partnership will revert to Premium.
                    </p>
                </div>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-btn" @click="closeWidget"> Cancel </app-button>
                </div>
                <div class="action-container">
                    <app-button class="save-btn"> Save </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const AppInputRadio = () => import('@/components/common/app-input-radio');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'storefront-data-permission-widget',

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'app-input-radio': AppInputRadio,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            selected: null,
            Collaboration: [
                {
                    boldName: 'Collaboration access (Recommended):',
                    name: 'Grant your partner access to push marketing resources on your behalf.',
                    value: 'hello',
                },
            ],

            Analytics: [
                {
                    boldName: 'Analytics access:',
                    name:
                        'Grant your partner visibility into your analytics to help improve future content.',
                    value: 'hello',
                },
            ],
        };
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },
    },
};
</script>

<style>
.storefront-data-permission-widget .action-container {
    display: flex;
}

.storefront-data-permission-widget .cancel-btn {
    background: transparent;
    color: #382153;
    border: none;
    width: 127px;
    border: 1px solid #cac6cb;
    border-radius: 20px;
}

.storefront-data-permission-widget .cancel-btn:hover {
    background: #e9e9ef;
}

.storefront-data-permission-widget .widget-contents-container .content-create {
    padding: 0;
}

.storefront-data-permission-widget .content-create .app-text-editor-wrapper,
.storefront-data-permission-widget .content-create .app-text-editor,
.storefront-data-permission-widget .content-create .widget-container {
    height: 100%;
}

.storefront-data-permission-widget .content-create .widget-container .controls {
    display: none;
}

.storefront-data-permission-widget .access-container {
    position: relative;
    border: 2px solid #e9e9ef;
    border-radius: 22px;
    margin-bottom: 15px;
    margin-top: 15px;
}

.storefront-data-permission-widget .title {
    position: absolute;
    top: -11px;
    left: 225px;
    padding: 0px 25px;
    background-color: #ffffff;
    font-weight: 600;
}

.storefront-data-permission-widget .choice-container .container {
    padding: 25px;
}

.storefront-data-permission-widget .name {
    display: flex;
    align-items: center;
}

.storefront-data-permission-widget .name .app-logo {
    margin-right: 10px;
}

.storefront-data-permission-widget .container p {
    margin: 0px;
    font: normal normal normal 16px/11px Roboto;
    color: #382153;
}

.storefront-data-permission-widget .container .link {
    font: normal normal normal 16px/11px Roboto;
    letter-spacing: 0px;
    color: #18aeff;
}

.storefront-data-permission-widget .date {
    margin-right: 10px;
    padding-right: 10px;
    border-right: 2px solid #dcdbe0;
}

.storefront-data-permission-widget .date-container {
    margin-bottom: 240px;
}

.storefront-data-permission-widget .week {
    margin-right: 10px;
    padding-right: 10px;
    border-right: 2px solid #dcdbe0;
}

.storefront-data-permission-widget .description {
    font: normal normal normal 16px/20px Roboto;
    letter-spacing: 0px;
    color: #382153;
}

.storefront-data-permission-widget .app-button.pink {
    background: #f30070;
    margin-right: 10px;
}

.storefront-data-permission-widget .app-button.pink:hover {
    background-color: #d10e68;
}

.storefront-data-permission-widget .action-container .app-button {
    width: 148px;
}

.storefront-data-permission-widget .content-wrapper .description {
    font: 500 18px/24px Roboto;
    letter-spacing: 0px;
    color: #382153;
}

.storefront-data-permission-widget .content-wrapper .disclaimer {
    margin-top: 10px;
}

.storefront-data-permission-widget .content-wrapper .disclaimer .description {
    font: normal normal normal 16px/24px Roboto;
    letter-spacing: 0px;
    color: #382153;
}

.storefront-data-permission-widget .content-wrapper .disclaimer label {
    margin-bottom: 15px;
}

.storefront-data-permission-widget .content-wrapper .disclaimer .description {
    margin-bottom: 25px;
}

.storefront-data-permission-widget .app-input-radio .radio-option-label {
    color: #382153;
}

.storefront-data-permission-widget .app-input-radio .radio-option-label p {
    font-weight: 500;
}

.storefront-data-permission-widget .app-input-radio .circle {
    min-width: 30px;
}
</style>
